export default "__VITE_ASSET__xdIFMuGP__"